module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/sFacebook.cbc17f55.svg";